import { Pivot, PivotItem } from '@fluentui/react';
import * as React from 'react';
import Documents from '../details/documents/Documents';
import History from '../details/history/History';
import NonprofitDetail from '../details/nonprofit/NonprofitDetail';

const enum PivotLinkFormat {
  tabs = 'tabs'
}

const enum PivotLinkSize {
  large = 'large'
}

const BusinessAdminSmall: React.FunctionComponent = () => (
  <section id="business-view-small">
    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
      <NonprofitDetail />
    </div>
    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
      <Pivot linkFormat={PivotLinkFormat.tabs} linkSize={PivotLinkSize.large}>
        <PivotItem headerText="Document" itemIcon="Document">
          <div className="tile-content">
            <Documents ignoreHeader={true} />
          </div>
        </PivotItem>
        <PivotItem headerText="History" itemIcon="History">
          <div className="tile-content">
            <History ignoreHeader={true} />
          </div>
        </PivotItem>
      </Pivot>
    </div>
  </section>
);

export default BusinessAdminSmall;
